import React, { useState } from 'react';
import { TabsWrapper } from 'features/Big9Tips/styled';
import Button from 'ui/Button';
import Text from 'ui/Text';
import { TABS } from 'features/Big9Tips/utils';

const TabComp = ({ tab, activeTab, changeTab }) => {
    const active = activeTab === tab.tag;
    return (
        <Button
            margin={'0'}
            lightBlue={!active}
            onClick={() => changeTab(tab.tag)}
        >
            <Text
                capitalize
                padding={'0'}
                margin={'0'}
                condensed
                color={active ? '#fff' : '#333'}
                align={'center'}
                size={'x1'}
                bold
            >
                {tab.title}
            </Text>
        </Button>
    );
};

const TipsListTabs = ({ onChange = () => {} }) => {
    const [activeTab, setActiveTab] = useState(TABS.alle.tag);

    const changeTab = (state) => {
        setActiveTab(state);
        onChange(state);
    };

    return (
        <TabsWrapper>
            <TabComp
                tab={TABS.alle}
                activeTab={activeTab}
                changeTab={changeTab}
            />
            <TabComp
                tab={TABS.gameTips}
                activeTab={activeTab}
                changeTab={changeTab}
            />
            <TabComp
                tab={TABS.new}
                activeTab={activeTab}
                changeTab={changeTab}
            />
        </TabsWrapper>
    );
};

export default TipsListTabs;
